import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installClientErrorReporter } from "./lib/errorReporter";
import { AppErrorBoundary } from "./components/app-error-boundary";

installClientErrorReporter();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
);
